import React from 'react';
import { ModalX } from '../../../components';
import { Button, Input } from '@material-tailwind/react';
import { useAddTeamMember, useAddUser, useUpdateUser } from '../../../custom-hooks/use-users';
import { NotifyError } from '../../../utils/functions';


// Functional component
const CustomerFormModal = ({
    isOpen,
    onClose,
    isUpdating,
    updatingUserId,
    defaultData,
    callback = () => { }
}) => {
    // * ----------------------------------------------------------------------------------------------------- Mutations
    const addUserMutation = useAddUser();
    const updateUserMutation = useUpdateUser();
    const addTeamMemberMutation = useAddTeamMember();

    // * ----------------------------------------------------------------------------------------------------- State variables
    const [formData, setFormData] = React.useState(defaultData);

    // * ----------------------------------------------------------------------------------------------------- Handlers
    // Handle form input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle form submit
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isUpdating) {
                await updateUserMutation.mutateAsync({ userId: updatingUserId, data: formData });

            } else {
                if (formData.teamId) {
                    await addTeamMemberMutation.mutateAsync(formData);
                }
                else {
                    // Update user logic
                    await addUserMutation.mutateAsync(formData);
                }
            }
            onClose(false);
            setFormData(defaultData);
        } catch (error) {
            console.error(error);
            NotifyError(error.response.data.message, error);
        }
        finally {
            // TODO: Close the modal

            // TODO: Refresh data callback
            callback();
        }
    };

    // * ----------------------------------------------------------------------------------------------------- Render
    return (
        <ModalX
            isOpen={isOpen}
            onClose={() => onClose(false)}
            title={isUpdating ? "Update Customer" : "Add Customer"}
            maxWidth="md"
        >
            <form onSubmit={handleFormSubmit}>
                <div className="space-y-4">
                    <Input
                        label="Full Name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />
                    <Input
                        label="Email Address"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                    <Input
                        label="CNIC"
                        name="cnic"
                        value={formData.cnic}
                        onChange={handleInputChange}
                        required
                    />
                    {
                        !formData.teamId && (
                            <Input
                                label="Phone Number"
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                                required={!formData.teamId}
                            />
                        )
                    }
                </div>
                <div className="mt-4 flex justify-end space-x-2">
                    <Button
                        onClick={() => onClose(false)}
                        className="rounded-full"
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={updateUserMutation.isLoading || addUserMutation.isLoading}
                        loading={updateUserMutation.isLoading || addUserMutation.isLoading}
                        type="submit"
                        className="rounded-full flex gap-2"
                        color={isUpdating ? "blue" : "green"}
                    >
                        {isUpdating ? "Update" : "Add"}
                    </Button>
                </div>
            </form>
        </ModalX>
    );
};

export default CustomerFormModal;